export const menuControl = () => {
  const menuWrapper = document.querySelector('.js-headerMenu')
  const bodyElement = document.querySelector('body')

  if (!menuWrapper || !bodyElement) {
    return
  }

  const menuSummon = menuWrapper.querySelector('.js-headerMenuSummon')
  const menuDismiss = menuWrapper.querySelector('.js-headerMenuDismiss')
  const menuSlideout = menuWrapper.querySelector('.js-headerMenuSlideout')

  const subMenus = Array.from(menuWrapper.querySelectorAll('.js-headerMenuItem.-hasCarret'))

  if (menuSummon) {
    menuSummon.addEventListener('click', () => {
      if (menuSlideout) {
        menuSlideout.classList.add('-active')
        bodyElement.classList.add('-isLocked')
      }
    })
  }

  if (menuDismiss) {
    menuDismiss.addEventListener('click', () => {
      if (menuSlideout) {
        menuSlideout.classList.remove('-active')
        bodyElement.classList.remove('-isLocked')
      }
    })
  }

  subMenus.forEach((subMenu, i) => {
    const carret = subMenu.querySelector('.js-headerMenuCarret')
    if (carret) {
      carret.addEventListener('click', () => {
        if (subMenu.classList.contains('-isOpened')) {
          subMenu.classList.remove('-isOpened')
        } else {
          subMenu.classList.add('-isOpened')
        }
      })
    }
  })
}
